module.exports = __webpack_public_path__ + "img/internacional.5d98d33e.svg";